/**
 * @author       yontaek@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { EVENT_NAMES, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { Origin } from '@zcode/nr-utils'
import type { Listable, Property } from '@zcode/state-type'
import type { Dispatch, GetState } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'
import { getPreviousPage } from '../helpers/previousPageLocalStorage'

interface Props {
  entity?: Listable | Property | null
  extraPayload?: any
  index: number
  origin?: Origin
  page: number
}

export const mixpanelShortTermDetailClick =
  ({ entity, extraPayload = {}, index, origin, page }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const prevPage: string = getPreviousPage()

    extraPayload[PROP_NAMES.SEARCH_RESULT_PAGE] = page
    extraPayload[PROP_NAMES.SEARCH_RESULT_INDEX] = index

    const payload = {
      [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.DETAIL,
      [PROP_NAMES.PREVIOUS_PAGE]: prevPage,
      ...getCommonProps({
        state,
        entity,
        event: EVENT_NAMES.VIEW_PAGE,
        origin,
        pageName: PAGE_NAMES.DETAIL,
      }),
      ...extraPayload,
    }

    track({ event: EVENT_NAMES.VIEW_PAGE, payload })
  }
